<template>
  <pt-integral-task class="pt-integral-task__withData"></pt-integral-task>
</template>

<script>
import PtIntegralTask from './index'
export default {
  name: 'pt-integral-task__withData',
  components: {
    'pt-integral-task': PtIntegralTask
  }
}
</script>
